module.exports = __webpack_public_path__ + "static/media/first_header.14090819.svg";